import { useEffect, useState } from 'react';
import axios from 'axios';

function getRedirectUri() {
  return `${window.location.origin}${window.location.pathname}`;
}

function useOAuthFinalize() {
  const [message, setMessage] = useState('Finalisation de la connexion Google...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    const error = params.get('error');

    if (error) {
      setMessage('Connexion Google refusée ou interrompue.');
      window.opener?.postMessage({ type: 'google-oauth-error', message: error }, window.location.origin);
      window.close();
      return;
    }

    if (!code || !state) {
      setMessage('Réponse Google invalide.');
      window.opener?.postMessage({ type: 'google-oauth-error', message: 'Réponse OAuth invalide' }, window.location.origin);
      return;
    }

    const exchange = async () => {
      try {
        await axios.post('/api/auth/google/exchange', { code, state, redirect_uri: getRedirectUri() });
        setMessage('Compte Google connecté. Cette fenêtre va se fermer.');
        window.opener?.postMessage({ type: 'google-oauth-success' }, window.location.origin);
        window.close();
      } catch (requestError) {
        const detail = requestError.response?.data?.detail || 'Échec de la finalisation OAuth Google';
        setMessage(detail);
        window.opener?.postMessage({ type: 'google-oauth-error', message: detail }, window.location.origin);
      }
    };

    void exchange();
    // Intentionally run only once on mount: the OAuth exchange must happen
    // exactly once per redirect, using values read synchronously from the URL.
  }, []);

  return message;
}

export default function GoogleAuthCallbackPage() {
  const message = useOAuthFinalize();

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 px-6 text-center text-white" data-testid="google-auth-callback-page">
      <div className="max-w-md space-y-4 rounded-lg border border-zinc-800 bg-zinc-900/70 p-8">
        <h1 className="text-xl font-semibold">Connexion Google</h1>
        <p className="text-sm text-zinc-400">{message}</p>
      </div>
    </div>
  );
}
